export default __webpack_public_path__ + "static/media/gallery-wip-assembly_02.4b04b095.jpg";